<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <card>
            <v-spacer/>
            <v-dialog
              v-model="dialog"
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs12
                    sm12
                    md12>
                    <base-input
                      v-model="search"
                      :loading="loading"
                      label="Search"
                      placeholder="Search..."
                      hide-details
                      @keyup.enter="index"/>
                  </v-flex>
                </v-layout>
              </template>
              <card
                :title="$t(editedItem.subject_type.replace(/\\/g, '')) + ' Log detail'"
                class="each-log">
                <v-container grid-list-md >
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm12
                      md12>
                      {{ editedItem.created_at | moment("from") }}
                      {{ editedItem.causer ? editedItem.causer.name : '' }}
                      {{ $t(editedItem.description) }}

                      the following attributes for
                      "{{ $t(editedItem.subject_type.replace(/\\/g, '')) }}(id: {{ editedItem.subject_id }})"
                    </v-flex>
                    <br>
                    <v-flex
                      v-for="(attribute, key) in editedItem.properties.attributes"
                      v-if="attribute !== editedItem.properties.old[key]"
                      xs12
                      sm12
                      md12>
                      <b style="font-size: 15px">{{ key }}:</b>
                      <div class="each-attribute">
                        <div
                          class="ql-snow each-value">
                          <div class="ql-editor">
                            <div v-html="editedItem.properties.old[key]"/>
                          </div>
                        </div>
                        <div
                          style="text-align: center;">
                          👆 ---change to---- 👇
                        </div>
                        <div class="ql-snow each-value">
                          <div class="ql-editor">
                            <div v-html="attribute"/>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-card-actions>
                  <base-button
                    @click="close">Close</base-button>
                </v-card-actions>
              </card>
            </v-dialog>
            <v-data-table
              :headers="headers"
              :items="ActivityLogList"
              :pagination.sync="pagination"
              :total-items="totalActivityLogs"
              :loading="loading"
              :light="false"
              class="table table-striped"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="showItem(props.item)">

                  <td>{{ props.item.id }}</td>
                  <td>
                    {{ $t(props.item.description) }}
                  </td>
                  <td>
                    {{ $t(props.item.subject_type.replace(/\\/g, '')) }}
                  </td>
                  <td>
                    {{ props.item.causer ? props.item.causer.name : '' }}
                  </td>
                  <td>
                    {{ props.item.created_at | moment("from") }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </card>
        </div>
      </v-flex>

      <v-snackbar
        v-model="snack"
        :timeout="5000"
        :color="snackColor">
        {{ snackText }}
        <v-btn
          flat
          @click="snack = false">Close</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BaseButton from '@/components/BaseButton'

export default {
  components: { BaseButton },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {
      rowsPerPage: 10,
      sortBy: 'id',
      descending: 'true'
    },
    ActivityLogList: [

    ],
    totalActivityLogs: 0,
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,

    search: '',
    headers: [
      {
        text: 'Id',
        value: 'id'
      },
      {
        text: 'Type',
        value: 'description'
      },
      {
        text: 'Subject',
        value: 'subject_type'
      },
      {
        text: 'User',
        value: 'causer.name'
      },
      {
        text: 'Time',
        value: 'created_at',
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      causer_id: '',
      causer: {
        name: ''
      },
      description: '',
      properties: {
        attributes: {},
        old: {}
      },
      subject_type: '',
      created_at: ''
    },
    defaultItem: {
      id: '',
      causer_id: '',
      causer: {
        name: ''
      },
      description: '',
      properties: {
        attributes: {},
        old: {}
      },
      subject_type: '',
      created_at: ''
    }
  }),

  computed: {
    ...mapState('app', ['color'])
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    pagination: {
      handler () {
        this.index()
      },
      deep: true
    }
  },

  methods: {
    index () {
      this.$store.state.spinning = true
      this.loading = true
      const params = new URLSearchParams(this.pagination)

      params.append('search', this.search)
      let self = this
      axios.get('/logs?' + params.toString())
        .then(response => {
          self.ActivityLogList = response.data.data
          self.totalActivityLogs = response.data.total
          self.$store.state.spinning = false
          self.loading = false
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
          self.$store.state.spinning = false
          self.loading = false
          console.log(err.response.data.errors)
        })
    },

    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    // object.assign fills in the empty object with the properties of item
    showItem (item, dbox = true) {
      this.editedIndex = this.ActivityLogList.indexOf(item)
      this.editedItem = item
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
.each-log {
  color: white;
}
.each-value {
  border: 1px solid rgb(128,128,128);
  border-radius: 8px;;
  font-size: 12px;
  margin-left: 30px;
  padding: 5px;
}
.ql-editor {
  min-height: unset;
}
</style>
